import { GameDayModel } from '../../models/gameday-model';

export interface GamedayState {
  deal: GameDayModel.Deal;
  orders: GameDayModel.Order[];
  filters: GamedayFiltersState;
  settings: GamedaySettingsState;
  isLoading: boolean;
}

export interface GamedayFiltersState {
  viewType: GameDayViewType;
  seriesId: string[];
  ignoreStocks: boolean;
  isSealedBid: boolean;
  legendCategories: string[];
  searchByAccountManager: AccountManager;
}

export interface GamedaySettingsState {
  isAutoUpdateTurnedOn: boolean;
  showMarketDrawers?: boolean;
}

export enum GameDayViewType {
  PriorityType = 'PriorityType',
  RetailType = 'RetailType',
  ManagersType = 'ManagersType',
  MoneyType = 'MoneyType',
  InstitutionalType = 'InstitutionalType'
}

export interface AccountManager {
  id?: number;
  name?: string;
  type: string;
  priority?: GameDayModel.AccountPriority;
}
